import React from 'react';
import { Box, TextButton, Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../../../../domainSearchSuite.module';
import { urls } from '../../../../Navigation/urls';
import { RECONNECT_VIA_NAMESERVERS_ARTICLE_ID, WIX_VIBE_DOMAINS_ARTICLE_ID } from './supportArticleIds';
export const ExternalViewerPointingDomain = _ref => {
  let {
    domainName,
    datahook
  } = _ref;
  const {
    Trans,
    locale
  } = DomainSearchSuiteModule.internals.useTranslations();
  const instructionsUrl = urls.supportArticle({
    id: RECONNECT_VIA_NAMESERVERS_ARTICLE_ID,
    locale,
    referralAdditionalInfo: 'pointing error message'
  });
  const learnMoreUrl = urls.supportArticle({
    id: WIX_VIBE_DOMAINS_ARTICLE_ID,
    locale,
    referralAdditionalInfo: 'pointing error message'
  });
  const linkButton = href => /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    weight: "normal",
    as: "a",
    target: "_blank",
    href: href,
    onClick: () => {
      DomainSearchSuiteModule.internals.bi.onClickLink == null || DomainSearchSuiteModule.internals.bi.onClickLink({
        link: href,
        domain: domainName
      });
    }
  });
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    marginTop: "SP4",
    textAlign: "center",
    dataHook: datahook
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.wix_vibe.pointing",
    components: [linkButton(instructionsUrl), linkButton(learnMoreUrl)]
  })));
};
//# sourceMappingURL=ExternalViewerPointingDomain.js.map